import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/types/store";
import { useAppDisPatch } from "src/utils/common";
import { getToken } from "src/store/auth/get-token/actions";

import { QAndAItem } from "./q-and-a-item";

export const QAndA = () => {
  const dispatch = useAppDisPatch();
  const navigate = useNavigate();
  const authStore = useSelector((state: RootState) => state.getToken);

  const onGetToken = () => {
      dispatch(getToken(navigate));
    }

  const answers = [
    {
      question: 'What is remit.ai?',
      answer: 'remit.ai is an intelligent remittance platform designed to help you send money internationally with ease. Powered by AI, it allows users to interact via WhatsApp or web interface for fast and reliable money transfers. We are backed by Ample Transfers Pte Ltd, a licensed Major Payment Institution (MPI) regulated by the Monetary Authority of Singapore (MAS). You can verify our license and regulatory status <a target="_blank" class="text-pink-theme-1 underline" href="https://ampl.fyi/licence">here</a>.'
    },
    {
      question: 'How does remit.ai work?',
      answer: `remit.ai functions like a personal assistant for remittance. Simply chat with us via WhatsApp or our website to get started—no sign-up required. You can enquire, initiate, and track your transactions seamlessly through the platform. To start transacting, we'll first need to register you, and the KYC process requires you to establish your identity, which will involve providing your identity documents.`
    },
    {
      question: 'Is remit.ai safe and secure?',
      answer: `Yes, remit.ai uses state-of-the-art encryption and security protocols to ensure that your transactions and personal information are safe. We adhere to international standards and comply with regulatory requirements such as the <a target="_blank" class="text-pink-theme-1 underline" href='https://www.mas.gov.sg/regulation/notices/psn01-aml-cft-notice---specified-payment-services'>MAS PSN01</a>.`
    }
  ]

  return (
    <div className="flex justify-center text-[#242424] mt-[100px] mb-[100px]">
      <div className="w-[956px] flex gap-8 flex-col md:flex-row">
        <div className="md:text-[48px] text-[32px] font-[700] w-[250px]">Frequently Asked Questions</div>
        <div className="flex-1">
          {
            answers.map((item, index) => (
              <QAndAItem answer={item.answer} question={item.question} key={index} isShowLine={index < answers?.length - 1 }/>
            ))
          }

          <div className="flex items-center justify-left gap-4">
            <a href="/faq" target="_blank" rel="noreferrer">
            <Button
            type="primary"
            className="h-[56px] bg-[#f4768D] text-[16px] !font-[600] px-8 mt-6 font-rale-way gap-2"
            >
              All FAQs
            </Button>
            </a>
            <Button
            loading={authStore.isLoading}
            onClick={onGetToken}
            type='default'
            className="h-[56px] !border-pink-500 !text-black !bg-transparent text-[16px] !font-[600] px-8 mt-6 font-rale-way gap-2"
            >Chat
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}